import moment from 'moment';
import placeholder from '../../assets/img/img1.jpg';

// Patient name formatting
export const patientname = (user, pid = false) => {
  const patientId = pid ? `(${formatPatientId(user)})` : '';
  // console.log(user,'user names--------------')
  return user ? `${user?.first_name} ${user?.last_name} ${patientId}` : '---';

};

const formatPatientId = data => {
  if (!data) return '';
  if (data.is_out_patient) return 'OPD';

  let formattedId = String(data.id);
  let len = 7 - formattedId.length;
  while (len >= 0) {
    formattedId = '0' + formattedId;
    len--;
  }
  return formattedId;
};

// Avatar URL handling
export const parseAvatar = avatar => {
  if (!avatar) return placeholder;

  if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
    return avatar;
  }

  if (avatar.includes('/images/') || avatar.includes('/dojah/') || avatar.includes('/avatars/')) {
    return `${process.env.REACT_APP_API_URL}public/portal?url=${avatar}&method=GET`;
  }

  return `${process.env.REACT_APP_API_URL}public/portal?url=images/${avatar}`;
};

// Media room ID generation
export const generateMediaRoomId = ({ patientId, doctorId }) => {
  return `${patientId}_${doctorId}`;
};

// Date/time formatting
export const formatMessageTime = timestamp => {
  const now = moment();
  const msgTime = moment(timestamp);

  if (now.diff(msgTime, 'days') === 0) {
    return msgTime.format('h:mm A');
  } else if (now.diff(msgTime, 'days') === 1) {
    return `Yesterday ${msgTime.format('h:mm A')}`;
  }
  return msgTime.format('MMM DD, h:mm A');
};

// Call duration formatting
export const formatCallDuration = seconds => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};